import React from "react";
import { Spinner } from "./spinner";

export class LoadingContainer extends React.Component {
    render() {
        return (
            <div className="d-flex justify-content-center align-items-center py-5">
                <div>
                    <Spinner />
                </div>
            </div>
        );
    }
}
